import { EOtherIncomeType } from '@if/core/types'
import { formatCurrencyNoDecimals } from '@if/core/utils'
import { useCurrentLang, useOtherIncomeTypesEnum } from '../../../data/selectors/app-config-selectors'
import { CreditApplication } from '../../../data/types'

interface Props {
  otherIncomeId: string | undefined
  isForApplicant: boolean
  creditApplication: CreditApplication
}

const OtherIncomeTaskDescription = ({ otherIncomeId, isForApplicant, creditApplication }: Props) => {
  const otherIncomeTypeEnum = useOtherIncomeTypesEnum()
  const lang = useCurrentLang()

  const getOtherIncomeFromId = () => {
    if (otherIncomeId) {
      const otherIncomes = isForApplicant
        ? creditApplication.applicant.otherIncomes
        : creditApplication.coApplicant?.otherIncomes
      return otherIncomes?.find((x) => x.id === otherIncomeId)
    }
    return undefined
  }

  const otherIncomeJob = getOtherIncomeFromId()
  return (
    <div>
      {otherIncomeJob?.typeId &&
        otherIncomeTypeEnum[otherIncomeJob?.typeId][lang].concat(
          `${
            otherIncomeJob?.typeId === EOtherIncomeType.Other ? ` : ${otherIncomeJob.description}` : ''
          } (${formatCurrencyNoDecimals(otherIncomeJob?.annualAmount)})`,
        )}
    </div>
  )
}

export default OtherIncomeTaskDescription
